import { ICardLogos } from '../../interfaces';
import visaCard from '../assets/visa.svg';
import amexCard from '../assets/amex.svg';
import mastercardCard from '../assets/mastercard.png';
import payPalCard from '../assets/pay-pal.png';

// TODO: ignored these "cannot assign string to FunctionComponent<SVG..."
// errors to get monorepo building
const cardLogos: ICardLogos = {
  // @ts-ignore
  visa: visaCard,
  // @ts-ignore
  amex: amexCard,
  mastercard: mastercardCard,
  paypal: payPalCard,
};

export default cardLogos;
